module.exports = __webpack_public_path__ + "static/img/活动图-02.40572b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/活动图-02.png
// module id = OfTJ
// module chunks = 16